<template>
  <div class="city-list">
    <list-page-header-no-line :page-info="pageInfo">

       <div class="hero-search__left">
         <div class="hero-search__select fw">
           <div class="hero-search__title"></div>
            <v-select :options="dorms" placeholder="Yurt Adı ile ara..." @onselect="selectDorm"/>
            </div>
            </div>
      <v-button
        class="hero-search__submit green"
        icon="icon-search"
        icon-position="left"
        title="Yurt Ara"
        @click.native="selectDorm"
      />
    </list-page-header-no-line>
    <FeaturedDormsNoTabs />

  </div>
</template>

<script>
import ListPageHeaderNoLine from '@/components/ListPageHeaderNoLine'
import FeaturedDormsNoTabs from '@/components/Home/FeaturedDormsNoTabs.vue'
import axios from 'axios'
export default {
  name: 'DormSearch',
  components: {
    ListPageHeaderNoLine, FeaturedDormsNoTabs
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Yurt Arama',
       meta: [
         { name: 'description', content: this.pageInfo.text },
         { name: 'keywords', content: 'yurt ara, özel yurt bul, yurt bulma, yurtlar burada, tüm yurtlar, erkek öğrenci yurtları, kız öğrenci yurtları' }
       ],
       link: [
         { rel: 'canonical', href: this.url }
       ]      
    }
  },  
  data () {
    return {
      url: '',
      pageInfo: {
        icon: require('@/assets/img/yurt-ara.svg'),
        title: '<span class="color-light-green">Yurt adına</span> göre ara!',
        text: 'Hayalini kurduğun üniversite hayatı için doğru yurdu seçmek çok önemli! Şehrindeki en popüler yurtları senin için bir araya getirdik!'
      },
      dorms: [],
      cityID: null,
      featuredCities: [],
      cities: [],
      searchUrl: {},
      errors: []
    }
  },
  methods: {     
    onSelect (opt) {
      // console.log(opt)
    },
    selectDorm (opt) {

      // let selected = this.$refs.myinput.value
      let selectedDorm  = this.dorms.find(function (dorm) { return dorm.name === opt.name } )
      if(selectedDorm) {
        this.$router.push({ name: 'DormDetail', params: { slug: selectedDorm.slug, id: opt.id } })
        
        window.localStorage.setItem('dormid', opt.id)
         let url = window.location.origin + '/yurt-arama'
        //let url = 'https://yurtlarburada.com/' + slug + '-y-' + opt.id
        window.localStorage.setItem('url', url)
      } 

    },
    getPopularCities () {
      let self = this
      axios.get('/site/home/cities?take=7')
        .then(response => {
          self.featuredCities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getDormsList () {
      let self = this
      axios.get('/site/search/dorms')
        .then(response => {
           self.dorms = response.data 
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    this.getPopularCities()
    this.getDormsList()
    this.url = window.location.origin + '/yurt-arama'
  },
  mounted () {
    var self = this
/*     this.$refs.myinput.addEventListener('input', function (evt) {
    self.selectDorm()
  }) */
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/city-list";
</style>
